/** Run a task after the browser has had a chance to paint. */
export function afterNextPaint(task: () => void): () => void {
    let frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(task);
    });
    return () => cancelAnimationFrame(frame);
}

/** Resolves once the browser has had a chance to paint. */
export function nextPaint(): Promise<void> {
    return new Promise(resolve => {
        afterNextPaint(resolve);
    });
}
